import { OFFER_KIND } from '../../../../../../views/menu/offers/constants';

export default {
  title: "Dettagli dell'offerta",
  types: {
    [OFFER_KIND.PERCENTAGE_OFF_BY_MIN_SPEND_VALUE]: {
      title: 'Imposta la spesa minima e lo sconto %',
      qualifying_criteria: {
        title: 'Importo minimo di spesa',
        description: "Imposta l'importo di spesa minimo",
      },
      details: {
        title: 'Sconto %',
        description: 'Imposta lo sconto che i clienti riceveranno sul loro ordine',
      },
    },
    [OFFER_KIND.PERCENTAGE_OFF_BY_PRODUCTS]: {
      title: 'Imposta gli articoli idonei e lo sconto %',
      qualifying_criteria: {
        title: 'Articoli scontati',
        description: 'Seleziona gli articoli su cui stai applicando uno sconto.',
      },
      details: {
        title: 'Sconto %',
        description: 'Imposta lo sconto che i clienti riceveranno sul loro ordine',
      },
    },
    [OFFER_KIND.AMOUNT_OFF_BY_PRODUCTS]: {
      title: 'Imposta gli articoli idonei e lo sconto {{currency}}',
      qualifying_criteria: {
        title: 'Articoli scontati',
        description: 'Seleziona gli articoli su cui stai applicando uno sconto.',
      },
      details: {
        title: 'Sconto {{currency}}',
        description: 'Imposta lo sconto che i clienti riceveranno sul loro ordine',
      },
    },
    [OFFER_KIND.AMOUNT_OFF_BY_MIN_SPEND_VALUE]: {
      title: 'Imposta la spesa minima e lo sconto {{currency}}',
      qualifying_criteria: {
        title: 'Importo minimo di spesa',
        description: "Imposta l'importo di spesa minimo",
      },
      details: {
        title: 'Sconto {{currency}}',
        description: 'Imposta lo sconto che i clienti riceveranno sul loro ordine',
      },
    },
    [OFFER_KIND.FREE_ITEM_BY_MIN_SPEND_VALUE]: {
      title: 'Imposta la spesa minima e gli articoli gratuiti',
      qualifying_criteria: {
        title: 'Importo minimo di spesa',
        description: "Imposta l'importo che il cliente deve spendere per ricevere l'articolo gratuito.",
      },
      details: {
        title: 'Articoli gratuiti:',
        description: "Seleziona l'articolo (o gli articoli) gratuito tra cui il cliente può scegliere.",
      },
    },
    [OFFER_KIND.FREE_ITEM_BY_PRODUCTS]: {
      title: "Scegli i requisiti dell'offerta",
      qualifying_criteria: {
        title: 'Articoli idonei',
        description: "Seleziona gli articoli che il cliente deve ordinare per ricevere l'articolo gratuito.",
      },
      details: {
        title: 'Articoli gratuiti:',
        description: "Seleziona l'articolo (o gli articoli) gratuito tra cui il cliente può scegliere.",
      },
    },
    [OFFER_KIND.BOGO]: {
      title: "Scegli i requisiti dell'offerta",
      qualifying_criteria: {
        title: 'Articoli idonei',
        description: 'Seleziona la categoria da cui il cliente deve scegliere per ricevere un articolo gratuito.',
      },
      details: {
        title: 'Articolo gratuito',
        description:
          'I clienti possono selezionare il secondo articolo tra quelli idonei selezionati. Il cliente riceverà gratuitamente il meno costoso dei due.',
      },
    },
  },
};
